import { createSlice } from "@reduxjs/toolkit";
import { API_STATUSES } from "redux/_helpers/statuses";

const commonReducers = createSlice({
  name: "commonReducers",
  initialState: {
    loginData: [],
    loginStatus: API_STATUSES.REQUEST,
    pinsEditModeReduxState: false, // Enable and Disable Edit Button
    pinsAdminModeReduxState: false, // Enable and Disable Admin Button
    updatedPinLocationReduxState: [],
    addNewTeeMarkerSettingsData: [],
    addNewTeeMarkerSettingsStatus: API_STATUSES.REQUEST,
    sharedTeeMarkerSettingsStatus: API_STATUSES.REQUEST,
    deleteTeeSettingsStatus: API_STATUSES.REQUEST,
    teeMarkerLoaderStatus: false,
    getPackageManifestsData: [],
    getPackageManifestsStatus: API_STATUSES.REQUEST,
    verficationLinkData: [],
    verficationLinkStatus: API_STATUSES.REQUEST,
    assignManifestToCarsData: false,
    assignManifestToCarsStatus: API_STATUSES.REQUEST,
    getExportUsageState: "",
    getExportUsageStatus: API_STATUSES.REQUEST,
    getRoundsByDayState: {},
    getRoundsByDayStatus: API_STATUSES.REQUEST,
    getPrivilegesListAction: [],
    getPrivilegesListStatusAction: API_STATUSES.REQUEST,
    getPrivilegeAction: [],
    getPrivilegeStatusAction: API_STATUSES.REQUEST,
    getRolesListAction: [],
    getRolesListStatusAction: API_STATUSES.REQUEST,
    getRoundsByCarState: [],
    getRoundsByCarStatus: API_STATUSES.REQUEST,
    siteSetupData: [],
    siteSetupStatus: API_STATUSES.IDLE,
    siteSettingsDataReduxState: [],
    siteSettingsDataReduxStateStatus: API_STATUSES.REQUEST,
    siteSettingsDataReduxState2: [],
    siteSettingsDataReduxStateStatus2: API_STATUSES.REQUEST,
    mapInformationData: [],
    getCustomerServiceProfileStatus: API_STATUSES.REQUEST,
    getCustomerServiceProfileData: [],
    saveCustomerServiceProfileSettingStatus: API_STATUSES.REQUEST,
    mapInformationStatus: API_STATUSES.REQUEST,
    resetUsernameData: [],
    resetUsernameStatus: API_STATUSES.REQUEST,
    resetSiteDataVersionAction: [],
    resetSiteDataVersionStatusAction: API_STATUSES.IDLE,
    sendMapDataAction: [],
    sendMapDataStatusAction: API_STATUSES.REQUEST,
    sendGreenViewDataAction: [],
    sendGreenViewDataStatusAction: API_STATUSES.REQUEST,
    sendSiteDataAction: [],
    sendSiteDataStatusAction: API_STATUSES.REQUEST,
    sendPOIDataAction: [],
    sendPOIDataStatusAction: API_STATUSES.REQUEST,
    scheduleSiteDataPublishAction: null,
    scheduleSiteDataPublishStatusAction: API_STATUSES.REQUEST,
    sendTeeMarkerDataAction: [],
    sendTeeMarkerDataStatusAction: API_STATUSES.IDLE,
    clearSiteDataAction: [],
    clearSiteDataStatusAction: API_STATUSES.IDLE,
    getVisageUsersAction: [],
    getVisageUsersStatusAction: API_STATUSES.REQUEST,
    getVisagaUsersListAction: [],
    getVisagaUsersListStatusAction: API_STATUSES.REQUEST,
    resetPOIsVersionAction: [],
    resetPOIsVersionStatusAction: API_STATUSES.REQUEST,
    resetMapsVersionAction: [],
    resetMapsVersionStatusAction: API_STATUSES.REQUEST,
    resetGreenViewVersionAction: [],
    resetGreenViewVersionStatusAction: API_STATUSES.REQUEST,
    resetTeeMarkersVersionAction: [],
    resetTeeMarkersVersionStatusAction: API_STATUSES.REQUEST,
    createSiteDataAction: [],
    createSiteDataStatusAction: API_STATUSES.REQUEST,
    resetSiteExtentsAndCtrPtToZeroAction: [],
    resetSiteExtentsAndCtrPtToZeroStatusAction: API_STATUSES.REQUEST,
    setSiteExtentsAction: [],
    setSiteExtentsStatusAction: API_STATUSES.REQUEST,
    disableAllAZsForMemberCarsAction: [],
    disableAllAZsForMemberCarsStatusAction: API_STATUSES.REQUEST,
    enableAllAZsForMemberCarsAction: [],
    enableAllAZsForMemberCarsStatusAction: API_STATUSES.REQUEST,
    changePasswordData: [],
    changePasswordStatus: API_STATUSES.REQUEST,
    resetPasswordData: [],
    resetPasswordStatus: API_STATUSES.IDLE,
    getCarsData: [],
    getCurrentCarsData: [],
    getCarsStatus: API_STATUSES.REQUEST,
    getCarPathActionZone: [],
    getCarPathActionZoneStatus: API_STATUSES.REQUEST,
    holeMarkerData: [],
    holeMarkerStatus: API_STATUSES.REQUEST,
    dashboardPaceData: [],
    publishSetupData: null,
    dashboardPaceStatus: API_STATUSES.REQUEST,
    sendMessagesResponse: [],
    sendMessagesStatus: API_STATUSES.REQUEST,
    cannedMessagesData: [],
    cannedMessagesStatus: API_STATUSES.REQUEST,
    getAnnouncementsData: [],
    getAnnouncementsStatus: API_STATUSES.REQUEST,
    acknowledgeAnnouncementsData: [],
    acknowledgeAnnouncementsStatus: API_STATUSES.REQUEST,
    mapImageData: [],
    mapImageStatus: API_STATUSES.REQUEST,
    mapXYPointsData: [],
    mapXYPointsStatus: API_STATUSES.REQUEST,
    getExportRoundByCarState: null,
    getExportRoundByCarStatus: API_STATUSES.REQUEST,
    carHistoryListData: [],
    carHistoryListStatus: API_STATUSES.REQUEST,
    specificCarHistoryData: [],
    carHistoryData: [],
    specificCarHistoryStatus: API_STATUSES.REQUEST,
    allCarsHistoryData: [],
    allCarsHistoryStatus: API_STATUSES.REQUEST,
    siteSettingsData: {},
    siteSettingsStatus: API_STATUSES.REQUEST,
    saveEmailData: [],
    saveEmailStatus: API_STATUSES.REQUEST,
    deleteEmailData: [],
    deleteEmailStatus: API_STATUSES.REQUEST,
    alertMessageData: [],
    alertMessageStatus: API_STATUSES.REQUEST,
    sendTestEmailData: [],
    sendTestEmailStatus: API_STATUSES.REQUEST,
    updateEmailData: [],
    updateEmailStatus: API_STATUSES.REQUEST,
    stagingModeData: [],
    stagingModeDataStatus: API_STATUSES.REQUEST,
    kmlLayerData: "",
    kmlLayerDataStatus: API_STATUSES.IDLE,
    messagesHistoryData: [],
    messagesHistoryStatus: API_STATUSES.REQUEST,
    getCarTrackData: [],
    getCarTrackStatus: API_STATUSES.REQUEST,
    getCarTracksData: [],
    getCarTracksStatus: API_STATUSES.REQUEST,
    getUserRole: [],
    getUserRoleStatus: API_STATUSES.REQUEST,
    carPropertiesData: [],
    carPropertiesStatus: API_STATUSES.REQUEST,
    carLocationData: [],
    carLocationStatus: API_STATUSES.REQUEST,
    siteLocationsData: [],
    siteLocationsStatus: API_STATUSES.REQUEST,
    updateCarTypeData: [],
    updateCarStatus: API_STATUSES.IDLE,
    putWelcomeScreenTextMessageData: [],
    putWelcomeScreenTextMessageStatus: API_STATUSES.IDLE,
    pinsApproachImagesStateData: [],
    pinsApproachImagesStateStatus: API_STATUSES.REQUEST,
    carPinPlacementStateData: [],
    carPinPlacementDataUpdated: {},
    carPinPlacementStateStatus: API_STATUSES.REQUEST,
    greensWithPinPlacementStateData: [],
    greensWithPinPlacementStateStatus: API_STATUSES.REQUEST,
    greensWithPinPlacementInfoStateData: {
      dailyRotationSets: [],
      specialRotationSets: [],
    },
    greenWithPinPlacementDataInfoReduxState: [],
    dailyRotationReduxState: false,
    updatePinRotationStateData: [],
    updatePinRotationStateDataStatus: API_STATUSES.IDLE,
    saveCourseRotationDaysData: [],
    saveCourseRotationDaysStatus: API_STATUSES.REQUEST,
    getRotationStateData: [],
    getRotationStateStatus: API_STATUSES.REQUEST,
    getCarUsageDetailState: {},
    getCarUsageDetailStatus: API_STATUSES.REQUEST,
    getRoundsByCarDetailState: {},
    getRoundsByCarDetailStatus: API_STATUSES.REQUEST,
    dailyPinPlacementStateData: [],
    dailyPinPlacementStateStatus: API_STATUSES.REQUEST,
    specialEventStateData: [],
    specialEventStateStatus: API_STATUSES.REQUEST,
    saveCourseRotationSetsData: [],
    saveCourseRotationSetsStatus: API_STATUSES.REQUEST,
    activeRotationStateData: [],
    activeRotationStateStatus: API_STATUSES.REQUEST,
    deleteDailyPinRotationStateData: [],
    deleteDailyPinRotationStateStatus: API_STATUSES.REQUEST,
    deleteDailySpecialEventStateData: [],
    deleteDailySpecialEventStateStatus: API_STATUSES.REQUEST,
    saveDragablePinStateData: [],
    saveDragablePinStateStatus: API_STATUSES.REQUEST,
    vduPutMessagesSettingData: [],
    vduPutMessagesSettingStatus: false,
    putScoreCardEmailData: [],
    putScoreCardEmailStatus: API_STATUSES.IDLE,
    putMaxHoleData: [],
    putMaxHoleStatus: API_STATUSES.IDLE,
    putRemovePersistentData: [],
    putRemovePersistentStatus: API_STATUSES.IDLE,
    putSavePersistentData: [],
    putSavePersistentStatus: API_STATUSES.IDLE,
    putDisableDistanceStatus: API_STATUSES.REQUEST,
    putBehindPaceWarningData: [],
    putBehindPaceWarningStatus: API_STATUSES.REQUEST,
    putPaceStatusTimeData: [],
    putPaceStatusTimeStatus: API_STATUSES.REQUEST,
    putUpdatedLockDownData: [],
    putUpdatedLockDownStatus: API_STATUSES.IDLE,
    putUpdateMemberCarTrackingData: [],
    putUpdateMemberCarTrackingStatus: API_STATUSES.IDLE,
    putSiteOffChargingData: [],
    putSiteOffChargingStatus: API_STATUSES.IDLE,
    getSiteOffPeakCharginData: [],
    getSiteOffPeakCharginStatus: API_STATUSES.REQUEST,
    getScheduledFleetLockdownData: [],
    getScheduledFleetLockdownStatus: API_STATUSES.REQUEST,
    getRoundTimeOutData: {},
    getRoundTimeOutStatus: API_STATUSES.REQUEST,
    putRoundTimeOutData: [],
    putRoundTimeOutStatus: API_STATUSES.IDLE,
    messagesFromCarsData: [],
    messagesFromCarsStatus: API_STATUSES.REQUEST,
    getMessagesFromCarsdata: [],
    getOnlyMessagesCarData: [],
    oldMessagesBackupData: [],
    newMessagesBackupData: [],
    newFoodOrderBackupData: [],
    oldFoodOrderBackupData: [],
    getMessagesFromCarsStatus: API_STATUSES.REQUEST,
    partialSiteSettingData: [],
    partialSiteSettingStatus: API_STATUSES.REQUEST,
    progressPendingForSiteData: [],
    progressPendingForSiteStatus: API_STATUSES.REQUEST,
    versionStringData: [],
    versionStringStatus: API_STATUSES.REQUEST,
    deleteCampaignData: [],
    deleteCampaignStatus: API_STATUSES.REQUEST,
    getCampaignsStateData: {},
    getCampaignsStatus: API_STATUSES.REQUEST,
    getImageGalleryData: [],
    getImageGalleryStatus: API_STATUSES.REQUEST,
    getAdImageData: [],
    getAdImageStatus: API_STATUSES.REQUEST,
    resetGetAdImageData: [],
    getAdInsertImageData: [],
    getAdInsertImageStatus: API_STATUSES.REQUEST,
    putImageDescData: "",
    putImageDescDataStatus: API_STATUSES.REQUEST,
    deleteImageData: "",
    deleteImageDataStatus: API_STATUSES.REQUEST,
    deleteMessagesSettingData: 0,
    deleteMessagesSettingStatus: API_STATUSES.REQUEST,
    saveCampaignDetailData: {},
    saveCampaignDetailStatus: API_STATUSES.REQUEST,
    saveTableCampaignDetailData: {},
    saveTableCampaignDetailStatus: API_STATUSES.REQUEST,
    copyCampaignsData: [],
    copyCampaignsStatus: API_STATUSES.REQUEST,
    deleteImagesData: [],
    deleteImagesStatus: API_STATUSES.REQUEST,
    deleteMultipleCampaignData: [],
    deleteMultipleCampaignStatus: API_STATUSES.REQUEST,
    getBaseCampaignData: {},
    getBaseCampaignStatus: API_STATUSES.REQUEST,
    getArchiveData: [],
    getArchiveStatus: API_STATUSES.REQUEST,
    PutCOGDataState: false,
    PutCOGDataStatus: API_STATUSES.REQUEST,
    deleteHoleAreaDataAction: false,
    deleteHoleAreaStatusAction: API_STATUSES.REQUEST,
    deleteSiteAreaDataAction: false,
    deleteSiteAreaStatusAction: API_STATUSES.REQUEST,
    putSiteAreaDataAction: {},
    putSiteAreaDataStatusAction: API_STATUSES.REQUEST,
    postSiteAreaDataStateAction: {},
    postSiteAreaStatusAction: API_STATUSES.REQUEST,
    putHoleAreaDataAction: {},
    putHoleAreaDataStatusAction: API_STATUSES.REQUEST,
    getWelcomeAdsData: {},
    getWelcomeAdsDataStatus: API_STATUSES.REQUEST,
    addImageData: [],
    addImageStatus: API_STATUSES.REQUEST,
    publishSiteData: false,
    publishSiteStatus: API_STATUSES.REQUEST,
    addActionZoneState: [],
    addActionZoneStatus: API_STATUSES.REQUEST,
    editActionZoneState: [],
    editActionZoneStatus: API_STATUSES.REQUEST,
    deleteActionZoneState: [],
    deleteActionZoneStatus: API_STATUSES.REQUEST,
    teeMarkerDataState: {},
    teeMarkerStatus: API_STATUSES.REQUEST,
    deleteTeeMarkerDataState: 0,
    deleteTeeMarkerStatus: API_STATUSES.REQUEST,
    poiMarkerDataState: {},
    poiMarkerStatus: API_STATUSES.REQUEST,
    deletePoiMarkerDataState: 0,
    deletePoiMarkerStatus: API_STATUSES.REQUEST,
    cogMarkerDataState: {},
    cogMarkerStatus: API_STATUSES.REQUEST,
    putPoiMarkerDataState: false,
    putPoiMarkerStatus: API_STATUSES.REQUEST,
    putTeeMarkerDataState: false,
    putTeeMarkerStatus: API_STATUSES.REQUEST,
    carBehindPaceDataStatus: API_STATUSES.REQUEST,
    carBehindPaceData: [],
    getDashboardState: [],
    getDashboardRidingCarState: [],
    getDashboardStatus: API_STATUSES.REQUEST,
    getDispatchCarRidingStatus: API_STATUSES.REQUEST,
    getWeatherInfoDataState: [],
    getWeatherInfoDataStatus: API_STATUSES.REQUEST,
    getActionZoneInfractionDataState: [],
    getActionZoneInfractionDataStatus: API_STATUSES.REQUEST,
    getActionZoneInfractionChildDataState: [],
    getActionZoneInfractionChildDataStatus: API_STATUSES.REQUEST,
    getCarSelectionState: [],
    getCarSelectionStatus: API_STATUSES.REQUEST,
    getCountCarBehindPaceState: 0,
    getCountCarBehindPaceStatus: API_STATUSES.REQUEST,
    getPaceByHoleState: {},
    getPaceByHoleStatus: API_STATUSES.REQUEST,
    getCarMovementState: [],
    getCarMovementStatus: API_STATUSES.REQUEST,
    getFleetReadinessState: [],
    getFleetReadinessStatus: API_STATUSES.REQUEST,
    getRoundsCompletedState: [],
    getRoundsCompletedStatus: API_STATUSES.REQUEST,
    getCarUsageState: [],
    getCarUsageStatus: API_STATUSES.REQUEST,
    getDashboardCampaignAdsState: [],
    getDashboardCampaignAdsStatus: API_STATUSES.REQUEST,
    getDashboardFullImagesDataState: [],
    getDashboardFullImagesDataStatus: API_STATUSES.REQUEST,
    getDashboardInsertImagesDataState: [],
    getDashboardInsertImagesDataStatus: API_STATUSES.REQUEST,
    getDashboardCartPathDetailData: [],
    getDashboardCartPathDetailStatus: API_STATUSES.REQUEST,
    getScoreCardState: [],
    getScoreCardStatus: API_STATUSES.REQUEST,
    getEmailAddressesState: [],
    getEmailAddressesStatus: API_STATUSES.REQUEST,
    putResendEmailState: [],
    putResendEmailStatus: API_STATUSES.REQUEST,
    getPreRoundCarsState: [],
    getPreRoundCarsStatus: API_STATUSES.REQUEST,
    getDashboardBatteryNotificationState: [],
    getDashboardBatteryNotificationStatus: API_STATUSES.REQUEST,
    getSiteAreasState: [],
    getSiteAreasStatus: API_STATUSES.REQUEST,
    getHoleAreasState: [],
    getHoleAreasStatus: API_STATUSES.REQUEST,
    getSingleCarTrackState: [],
    getSingleCarTrackStatus: API_STATUSES.REQUEST,
    HoleDataReduxState: [],
    holeDataPinsState: [],
    siteSettingDataReduxState: [],
    siteSettingDataReduxStateStatus: API_STATUSES.REQUEST,
    getTodayPinPositionDataReduxState: null,
    getTodayPinPositionDataReduxStatus: API_STATUSES.REQUEST,
    clickToDriveApiData: null,
    clickToDriveApiStatus: API_STATUSES.REQUEST,
    getDashboardFeatureSetState: {},
    getDashboardFeatureSetStatus: API_STATUSES.IDLE,
    putDashboardFeatureSetState: {},
    putDashboardFeatureSetStatus: API_STATUSES.IDLE,
    getFeatureSetState: [],
    getFeatureSetStateStatus: API_STATUSES.REQUEST,
    setNewFeatureStateData: [],
    setNewFeatureStateStatus: API_STATUSES.REQUEST,
    setCourseChangesResponseState: [],
    setCourseChangesStatusState: API_STATUSES.REQUEST,
    setUpdatedTeeMarkerSettingsData: [],
    setUpdatedTeeMarkerSettingsStatus: API_STATUSES.REQUEST,
    PutCpoSettingsStateData: [],
    PutCpoSettingsStatus: API_STATUSES.REQUEST,
    getFaultsData: [],
    getFaultsStatus: API_STATUSES.REQUEST,
    pinMovementDetectorReduxState: false,
    getFoodOrdersDataState: {},
    getFoodOrdersDataStatus: API_STATUSES.REQUEST,
    getFoodImageDataStatus: API_STATUSES.REQUEST,
    getFoodImageDataState: {},
    getFoodImageNameDataStatus: API_STATUSES.REQUEST,
    getFoodImageNameDataState: {},
    getFoodOrdersTabDataStatus: API_STATUSES.REQUEST,
    getFoodOrdersTabDataState: [],
    getFoodMenuTabDataStatus: API_STATUSES.REQUEST,
    getFoodMenuTabDataState: [],
    putFoodOrdersTabDataStatus: API_STATUSES.REQUEST,
    putFoodOrdersTabDataState: {},
    updatedCarsDataState: [],
    putLocalisationStatus: API_STATUSES.REQUEST,
    putLocalisationState: [],
    sharedCheckboxDataReduxState: [],
    sharedCheckboxStatusReduxState: API_STATUSES.REQUEST,
    getValidateZoneDataStatusAction: API_STATUSES.IDLE,
    getValidateZoneDataStateAction: [],
    getValidatePinDataStatusAction: API_STATUSES.IDLE,
    getValidatePinDataStateAction: [],
    getSiteSettingStatusAction: API_STATUSES.REQUEST,
    getSiteSettingStateAction: "",
    getPaceManifestStatusAction: API_STATUSES.REQUEST,
    getPaceManifestStateAction: "",
    getMessageManifestStatusAction: API_STATUSES.REQUEST,
    getMessageManifestStateAction: "",
    getLanguageManifestStatusAction: API_STATUSES.REQUEST,
    getLanguageManifestStateAction: "",
    getSimpleCarManifestStatusAction: API_STATUSES.REQUEST,
    getSimpleCarManifestStateAction: "",
    getManifestListStatusAction: API_STATUSES.REQUEST,
    getManifestListStateAction: [],
    getChangePasswordStatus: API_STATUSES.REQUEST,
    getChangePasswordState: {},
    getSimpleCarListStatus: API_STATUSES.REQUEST,
    getSimpleCarListState: [],
    getLanguageListStatus: API_STATUSES.REQUEST,
    getLanguageListState: [],
    getPaceListStatus: API_STATUSES.REQUEST,
    getPaceListState: [],
    getMessageListStatus: API_STATUSES.REQUEST,
    getMessageListState: [],
    getSettingListStatus: API_STATUSES.REQUEST,
    getSettingListState: [],
    putHoleDataStatus: API_STATUSES.REQUEST,
    putHoleDataState: false,
    carProductLoader: false,
    carProductStatus: API_STATUSES.REQUEST,
    carProductData: [],
    setMessageStatus: API_STATUSES.REQUEST,
    setMessageStatusAction: API_STATUSES.REQUEST,
    setMessageStateAction: [],
    uploadKmlDataStatus: API_STATUSES.IDLE,
    uploadKmlDataState: false,
    createHoleMapImageDataStatus: API_STATUSES.IDLE,
    createHoleMapImageDataState: {},
    processGreenViewDataStatus: API_STATUSES.IDLE,
    processGreenViewDataState: {},
    verifySiteSetupDataStatus: API_STATUSES.IDLE,
    verifySiteSetupDataState: {},
    putMaxVolumeSettingStatus: API_STATUSES.IDLE,
    sendMessageToMarshalsStatus: API_STATUSES.IDLE,
    sendMessageToMarshalsData: [],
    publishWaiverTemplatesStatus: API_STATUSES.REQUEST,
    unpublishWaiverTemplatesStatus: API_STATUSES.REQUEST,
    saveWaiverTemplatesStatus: API_STATUSES.REQUEST,
    saveWaiverTemplatesData: [],
    getWaiverTemplatesStatus: API_STATUSES.REQUEST,
    getWaiverTemplatesData: [],
    getTournSettingsStatus: API_STATUSES.REQUEST,
    getTournSettingsState: []
  },

  reducers: {
    loginUserData: (state, action) => {
      state.loginData = action.payload;
    },
    setSharedCheckboxDataReduxStateAction: (state, action) => {
      state.sharedCheckboxDataReduxState = action.payload;
    },
    setSharedCheckboxSTatusReduxStateAction: (state, action) => {
      state.sharedCheckboxStatusReduxState = action.payload;
    },
    setUpdatedCarsDataState: (state, action) => {
      state.updatedCarsDataState = action.payload;
    },
    setPinMovementDetectorAction: (state, action) => {
      state.pinMovementDetectorReduxState = action.payload;
    },
    setHoleDataPinsState: (state, action) => {
      state.holeDataPinsState = [...state.holeDataPinsState, action.payload];
    },
    setPinsEditModeReduxStateAction: (state, action) => {
      state.pinsEditModeReduxState = action.payload;
    },
    setPinsAdminModeReduxStateAction: (state, action) => {
      state.pinsAdminModeReduxState = action.payload;
    },
    setCustomerServiceProfileStatus: (state, action) => {
      state.getCustomerServiceProfileStatus = action.payload;
    },
    setCustomerServiceProfileData: (state, action) => {
      state.getCustomerServiceProfileData = action.payload;
    },
    saveCustomerServiceProfileSettingStatus: (state, action) => {
      state.saveCustomerServiceProfileSettingStatus = action.payload;
    },
    setClickToDriveApiDataAction: (state, action) => {
      state.clickToDriveApiData = action.payload;
    },
    setClickToDriveApiStatusAction: (state, action) => {
      state.clickToDriveApiStatus = action.payload;
    },
    resetHoleDataPinState: (state) => {
      state.holeDataPinsState = [];
    },
    getTodayPinPositionDataReduxStateAction: (state, action) => {
      state.getTodayPinPositionDataReduxState = action.payload;
    },
    getTodayPinPositionDataReduxStatusAction: (state, action) => {
      state.getTodayPinPositionDataReduxStatus = action.payload;
    },
    setHoleDataReduxState: (state, action) => {
      state.HoleDataReduxState = [...state.HoleDataReduxState, action.payload];
    },
    setUpdatedPinLocationReduxState: (state, action) => {
      state.updatedPinLocationReduxState = action.payload;
    },
    setLoginUserStatus: (state, action) => {
      state.loginStatus = action.payload;
    },
    getVerificationLinkData: (state, action) => {
      state.verficationLinkData = action.payload;
    },
    getVerificationLinkStatus: (state, action) => {
      state.verficationLinkStatus = action.payload;
    },

    assignManifestToCarsData: (state, action) => {
      state.assignManifestToCarsData = action.payload;
    },
    assignManifestToCarsStatus: (state, action) => {
      state.assignManifestToCarsStatus = action.payload;
    },

    resetUsernameData: (state, action) => {
      state.resetUsernameData = action.payload;
    },
    resetUsernameStatus: (state, action) => {
      state.resetUsernameStatus = action.payload;
    },
    changePasswordData: (state, action) => {
      state.changePasswordData = action.payload;
    },
    changePasswordStatus: (state, action) => {
      state.changePasswordStatus = action.payload;
    },

    resetPasswordData: (state, action) => {
      state.resetPasswordData = action.payload;
    },
    resetPasswordStatus: (state, action) => {
      state.resetPasswordStatus = action.payload;
    },

    getCarsDataAction: (state, action) => {
      state.getCarsData = action.payload;
    },

    getCurrentCarsDataAction: (state, action) => {
      state.getCurrentCarsData = action.payload;
    },
    getCarsStatusAction: (state, action) => {
      state.getCarsStatus = action.payload;
    },

    getExportRoundByCarState: (state, action) => {
      state.getExportRoundByCarState = action.payload;
    },

    getExportRoundByCarStatus: (state, action) => {
      state.getExportRoundByCarStatus = action.payload;
    },

    getVisageUsersAction: (state, action) => {
      state.getVisageUsersAction = action.payload;
    },

    getVisageUsersStatusAction: (state, action) => {
      state.getVisageUsersStatusAction = action.payload;
    },
    getVisagaUsersListAction: (state, action) => {
      state.getVisagaUsersListAction = action.payload;
    },
    getVisagaUsersListStatusAction: (state, action) => {
      state.getVisagaUsersListStatusAction = action.payload;
    },
    getCarPathActionZoneAction: (state, action) => {
      state.getCarPathActionZone = action.payload;
    },
    getCarPathActionZoneStatusAction: (state, action) => {
      state.getCarPathActionZoneStatus = action.payload;
    },
    holeMarkerDataAction: (state, action) => {
      state.holeMarkerData = action.payload;
    },
    holeMarkerStatusAction: (state, action) => {
      state.holeMarkerStatus = action.payload;
    },
    sendMessagesData: (state, action) => {
      state.sendMessagesResponse = action.payload;
    },
    sendMessagesStatus: (state, action) => {
      state.sendMessagesStatus = action.payload;
    },
    cannedMessagesData: (state, action) => {
      state.cannedMessagesData = action.payload;
    },
    cannedMessagesStatus: (state, action) => {
      state.cannedMessagesStatus = action.payload;
    },
    getAnnouncementsData: (state, action) => {
      state.getAnnouncementsData = action.payload;
    },
    getAnnouncementsStatus: (state, action) => {
      state.getAnnouncementsStatus = action.payload;
    },
    acknowledgeAnnouncementsData: (state, action) => {
      state.acknowledgeAnnouncementsData = action.payload;
    },
    acknowledgeAnnouncementsStatus: (state, action) => {
      state.acknowledgeAnnouncementsStatus = action.payload;
    },
    mapImageData: (state, action) => {
      state.mapImageData = action.payload;
    },  
    mapImageStatus: (state, action) => {
      state.mapImageStatus = action.payload;
    },
    mapXYPointsData: (state, action) => {
      state.mapXYPointsData = action.payload;
    },
    mapXYPointsStatus: (state, action) => {
      state.mapXYPointsStatus = action.payload;
    },
    getCarHistoryData: (state, action) => {
      state.carHistoryData = action.payload;
    },
    getCarHistoryStatus: (state, action) => {
      state.carHistoryListStatus = action.payload;
    },

    getRoundsByDayState: (state, action) => {
      state.getRoundsByDayState = action.payload;
    },
    getRoundsByDayStatus: (state, action) => {
      state.getRoundsByDayStatus = action.payload;
    },

    specificCarHistoryDataAction: (state, action) => {
      state.specificCarHistoryData = action.payload;
    },
    specificCarHistoryStatusAction: (state, action) => {
      state.specificCarHistoryStatus = action.payload;
    },
    allCarsHistoryDataAction: (state, action) => {
      state.allCarsHistoryData = action.payload;
    },
    allCarsHistoryStatusAction: (state, action) => {
      state.allCarsHistoryStatus = action.payload;
    },
    siteSettingsData: (state, action) => {
      state.siteSettingsData = action.payload;
    },
    siteSettingsStatus: (state, action) => {
      state.siteSettingsStatus = action.payload;
    },
    stagingModeDataAction: (state, action) => {
      state.stagingModeData = action.payload;
    },
    stagingModeStatusAction: (state, action) => {
      state.stagingModeDataStatus = action.payload;
    },
    saveEmailData: (state, action) => {
      state.saveEmailData = action.payload;
    },
    saveEmailStatus: (state, action) => {
      state.saveEmailStatus = action.payload;
    },
    deleteEmailData: (state, action) => {
      state.deleteEmailData = action.payload;
    },
    deleteEmailStatus: (state, action) => {
      state.deleteEmailStatus = action.payload;
    },
    alertMessageData: (state, action) => {
      state.alertMessageData = action.payload;
    },
    alertMessageStatus: (state, action) => {
      state.alertMessageStatus = action.payload;
    },
    sendTestEmailData: (state, action) => {
      state.sendTestEmailData = action.payload;
    },
    updateEmailData: (state, action) => {
      state.updateEmailData = action.payload;
    },
    updateEmailStatus: (state, action) => {
      state.updateEmailStatus = action.payload;
    },
    sendTestEmailStatus: (state, action) => {
      state.sendTestEmailStatus = action.payload;
    },
    kmlLayerData: (state, action) => {
      state.kmlLayerData = action.payload;
    },
    kmlLayerDataStatus: (state, action) => {
      state.kmlLayerDataStatus = action.payload;
    },
    messagesHistoryData: (state, action) => {
      state.messagesHistoryData = action.payload;
    },
    messagesHistoryStatus: (state, action) => {
      state.messagesHistoryStatus = action.payload;
    },
    fleetSettingslData: (state, action) => {
      state.fleetSettingslData = action.payload;
    },
    antiTamperSelectionData: (state, action) => {
      state.antiTamperSelectionData = action.payload;
    },
    antiTamperSelectionStatus: (state, action) => {
      state.antiTamperSelectionStatus = action.payload;
    },
    fleetSettingslData2: (state, action) => {
      state.fleetSettingslData2 = action.payload;
    },
    fleetSettingsStatus: (state, action) => {
      state.fleetSettingsStatus = action.payload;
    },
    fleetSettingsStatus2: (state, action) => {
      state.fleetSettingsStatus2 = action.payload;
    },
    getCarTrackData: (state, action) => {
      state.getCarTrackData = action.payload;
    },
    getCarTrackStatus: (state, action) => {
      state.getCarTrackStatus = action.payload;
    },
    getCarTracksData: (state, action) => {
      state.getCarTracksData = action.payload;
    },
    getCarTracksStatus: (state, action) => {
      state.getCarTracksStatus = action.payload;
    },
    getUserRoleStatus: (state, action) => {
      state.getUserRoleStatus = action.payload;
    },
    getUserRole: (state, action) => {
      state.getUserRole = action.payload;
    },
    carPropertiesData: (state, action) => {
      state.carPropertiesData = action.payload;
    },
    carPropertiesStatus: (state, action) => {
      state.carPropertiesStatus = action.payload;
    },
    carLocationData: (state, action) => {
      state.carLocationData = action.payload;
    },
    carLocationStatus: (state, action) => {
      state.carLocationStatus = action.payload;
    },
    carProductData: (state, action) => {
      state.carProductData = action.payload;
    },
    carProductStatus: (state, action) => {
      state.carProductStatus = action.payload;
    },
    carProductLoader: (state, action) => {
      state.carProductLoader = action.payload;
    },
    siteLocationsData: (state, action) => {
      state.siteLocationsData = action.payload;
    },
    siteLocationsStatus: (state, action) => {
      state.siteLocationStateStatus = action.payload;
    },
    siteSetupData: (state, action) => {
      state.siteSetupData = action.payload;
    },
    siteSetupStatus: (state, action) => {
      state.siteSetupStatus = action.payload;
    },
    siteSettingsDataReduxStateAction: (state, action) => {
      state.siteSettingsDataReduxState = action.payload;
    },
    siteSettingsDataReduxStateStatusAction: (state, action) => {
      state.siteSettingsDataReduxStateStatus = action.payload;
    },
    mapInformationData: (state, action) => {
      state.mapInformationData = action.payload;
    },
    mapInformationStatus: (state, action) => {
      state.mapInformationStatus = action.payload;
    },

    resetSiteDataVersionAction: (state, action) => {
      state.resetSiteDataVersionAction = action.payload;
    },
    resetSiteDataVersionStatusAction: (state, action) => {
      state.resetSiteDataVersionStatusAction = action.payload;
    },

    sendMapDataAction: (state, action) => {
      state.sendMapDataAction = action.payload;
    },
    sendMapDataStatusAction: (state, action) => {
      state.sendMapDataStatusAction = action.payload;
    },

    sendGreenViewDataAction: (state, action) => {
      state.sendGreenViewDataAction = action.payload;
    },
    sendGreenViewDataStatusAction: (state, action) => {
      state.sendGreenViewDataStatusAction = action.payload;
    },

    sendSiteDataAction: (state, action) => {
      state.sendSiteDataAction = action.payload;
    },
    sendSiteDataStatusAction: (state, action) => {
      state.sendSiteDataStatusAction = action.payload;
    },

    sendPOIDataAction: (state, action) => {
      state.sendPOIDataAction = action.payload;
    },
    sendPOIDataStatusAction: (state, action) => {
      state.sendPOIDataStatusAction = action.payload;
    },

    scheduleSiteDataPublishAction: (state, action) => {
      state.scheduleSiteDataPublishAction = action.payload;
    },
    scheduleSiteDataPublishStatusAction: (state, action) => {
      state.scheduleSiteDataPublishStatusAction = action.payload;
    },

    sendTeeMarkerDataAction: (state, action) => {
      state.sendTeeMarkerDataAction = action.payload;
    },
    sendTeeMarkerDataStatusAction: (state, action) => {
      state.sendTeeMarkerDataStatusAction = action.payload;
    },

    clearSiteDataAction: (state, action) => {
      state.clearSiteDataAction = action.payload;
    },
    clearSiteDataStatusAction: (state, action) => {
      state.clearSiteDataStatusAction = action.payload;
    },

    resetPOIsVersionAction: (state, action) => {
      state.resetPOIsVersionAction = action.payload;
    },
    resetPOIsVersionStatusAction: (state, action) => {
      state.resetPOIsVersionStatusAction = action.payload;
    },

    resetMapsVersionAction: (state, action) => {
      state.resetMapsVersionAction = action.payload;
    },
    resetMapsVersionStatusAction: (state, action) => {
      state.resetMapsVersionStatusAction = action.payload;
    },

    resetGreenViewVersionAction: (state, action) => {
      state.resetGreenViewVersionAction = action.payload;
    },
    resetGreenViewVersionStatusAction: (state, action) => {
      state.resetGreenViewVersionStatusAction = action.payload;
    },

    resetTeeMarkersVersionAction: (state, action) => {
      state.resetTeeMarkersVersionAction = action.payload;
    },
    resetTeeMarkersVersionStatusAction: (state, action) => {
      state.resetTeeMarkersVersionStatusAction = action.payload;
    },

    createSiteDataAction: (state, action) => {
      state.createSiteDataAction = action.payload;
    },
    createSiteDataStatusAction: (state, action) => {
      state.createSiteDataStatusAction = action.payload;
    },

    resetSiteExtentsAndCtrPtToZeroAction: (state, action) => {
      state.resetSiteExtentsAndCtrPtToZeroAction = action.payload;
    },
    resetSiteExtentsAndCtrPtToZeroStatusAction: (state, action) => {
      state.resetSiteExtentsAndCtrPtToZeroStatusAction = action.payload;
    },

    setSiteExtentsAction: (state, action) => {
      state.setSiteExtentsAction = action.payload;
    },

    setSiteExtentsStatusAction: (state, action) => {
      state.setSiteExtentsStatusAction = action.payload;
    },

    disableAllAZsForMemberCarsAction: (state, action) => {
      state.disableAllAZsForMemberCarsAction = action.payload;
    },
    disableAllAZsForMemberCarsStatusAction: (state, action) => {
      state.disableAllAZsForMemberCarsStatusAction = action.payload;
    },

    enableAllAZsForMemberCarsAction: (state, action) => {
      state.enableAllAZsForMemberCarsAction = action.payload;
    },
    enableAllAZsForMemberCarsStatusAction: (state, action) => {
      state.enableAllAZsForMemberCarsStatusAction = action.payload;
    },

    updateCarTypeData: (state, action) => {
      state.updateCarTypeData = action.payload;
    },
    updateCarStatus: (state, action) => {
      state.updateCarStatus = action.payload;
    },
    putWelcomeScreenTextMessageAction: (state, action) => {
      state.putWelcomeScreenTextMessageData = action.payload;
    },
    putWelcomeScreenTextMessageStatusAction: (state, action) => {
      state.putWelcomeScreenTextMessageStatus = action.payload;
    },
    putScoreCardEmailAction: (state, action) => {
      state.putScoreCardEmailData = action.payload;
    },
    putScoreCardEmailStatusAction: (state, action) => {
      state.putScoreCardEmailStatus = action.payload;
    },
    putMaxHoleServicesAction: (state, action) => {
      state.putMaxHoleData = action.payload;
    },
    putMaxHoleServicesStatus: (state, action) => {
      state.putMaxHoleStatus = action.payload;
    },
    putRemovePersistentCarTypeSettingAction: (state, action) => {
      state.putRemovePersistentData = action.payload;
    },
    putRemovePersistentCarTypeSettingStatus: (state, action) => {
      state.putRemovePersistentStatus = action.payload;
    },
    postSavePersistentCarTypeSettingAction: (state, action) => {
      state.putSavePersistentData = action.payload;
    },
    postSavePersistentCarTypeSettingStatus: (state, action) => {
      state.putSavePersistentStatus = action.payload;
    },
    putDisableDistanceAction: (state, action) => {
      state.putDisableDistanceData = action.payload;
    },
    
    putDisableDistanceStatus: (state, action) => {
      state.putDisableDistanceStatus = action.payload;
    },
    putBehindPaceWarningAction: (state, action) => {
      state.putBehindPaceWarningData = action.payload;
    },
    putBehindPaceWarningStatus: (state, action) => {
      state.putBehindPaceWarningStatus = action.payload;
    },
    putPaceStatusTimeAction: (state, action) => {
      state.putPaceStatusTimeData = action.payload;
    },
    putPaceStatusTimeStatus: (state, action) => {
      state.putPaceStatusTimeStatus = action.payload;
    },
    putUpdatedLockAction: (state, action) => {
      state.putUpdatedLockDownData = action.payload;
    },
    putUpdatedLockStatus: (state, action) => {
      state.putUpdatedLockDownStatus = action.payload;
    },
    putUpdateMemberCarTrackingAction: (state, action) => {
      state.putUpdateMemberCarTrackingData = action.payload;
    },
    putUpdateMemberCarTrackingStatus: (state, action) => {
      state.putUpdateMemberCarTrackingStatus = action.payload;
    },
    
    putSiteOffAction: (state, action) => {
      state.putSiteOffChargingData = action.payload;
    },
    putSiteOffStatus: (state, action) => {
      state.putSiteOffChargingStatus = action.payload;
    },

    getSiteOffPeakCharginData: (state, action) => {
      state.getSiteOffPeakCharginData = action.payload;
    },
    getSiteOffPeakCharginStatus: (state, action) => {
      state.getSiteOffPeakCharginStatus = action.payload;
    },
    getScheduledFleetLockdownData: (state, action) => {
      state.getScheduledFleetLockdownData = action.payload;
    },
    getScheduledFleetLockdownStatus: (state, action) => {
      state.getScheduledFleetLockdownStatus = action.payload;
    },

    getRoundTimeOutAction: (state, action) => {
      state.getRoundTimeOutData = action.payload;
    },
    getRoundTimeOutState: (state, action) => {
      state.getRoundTimeOutStatus = action.payload;
    },
    getMessagesFromCarsData: (state, action) => {
      state.getMessagesFromCarsData = action.payload;
    },
    getMessagesFromCarsStatus: (state, action) => {
      state.getMessagesFromCarsStatus = action.payload;
    },
    setOnlyMessagesReduxState: (state, action) => {
      state.getOnlyMessagesCarData = action.payload;
    },
    setOldMessagesBackUpReduxState: (state, action) => {
      state.oldMessagesBackupData = action.payload;
    },
    setNewMessagesBackUpReduxState: (state, action) => {
      state.newMessagesBackupData = action.payload;
    },
    setNewFoodOrderReduxState: (state, action) => {
      state.newFoodOrderBackupData = action.payload;
    },
    setOldFoodOrderReduxState: (state, action) => {
      state.oldFoodOrderBackupData = action.payload;
    },
    deleteMessagesReduxState: (state, action) => {
      const { id } = action.payload;
      const newData = state.getOnlyMessagesCarData.filter(
        (item) => item.Id !== id
      );
      state.getOnlyMessagesCarData = newData;
    },
    putRoundTimeOutData: (state, action) => {
      state.putRoundTimeOutData = action.payload;
    },
    putRoundTimeOutStatusAction: (state, action) => {
      state.putRoundTimeOutStatus = action.payload;
    },
    getPartialSiteSettingsData: (state, action) => {
      state.partialSiteSettingData = action.payload;
    },
    getPartialSiteSettingsStatus: (state, action) => {
      state.partialSiteSettingStatus = action.payload;
    },
    getProgressPendingForSiteData: (state, action) => {
      state.progressPendingForSiteData = action.payload;
    },
    getProgressPendingForSiteStatus: (state, action) => {
      state.progressPendingForSiteStatus = action.payload;
    },

    getVersionStringData: (state, action) => {
      state.versionStringData = action.payload;
    },
    getVersionStringStatus: (state, action) => {
      state.versionStringStatus = action.payload;
    },
    getSettingPresetData: (state, action) => {
      state.getSettingPresetData = action.payload;
    },
    getSettingPresetStatus: (state, action) => {
      state.getSettingPresetStatus = action.payload;
    },
    getDashboardCartPathDetailData: (state, action) => {
      state.getDashboardCartPathDetailData = action.payload;
    },
    getDashboardCartPathDetailStatus: (state, action) => {
      state.getDashboardCartPathDetailStatus = action.payload;
    },
    pinsApproachImagesStateDataAction: (state, action, changedNewData) => {
      const { size } = action.payload;
      const exists = state.pinsApproachImagesStateData.find(
        (item) => item.size === size
      );
      if (exists) {
        state.pinsApproachImagesStateData.filter((item) => item.size !== size);
      } else {
        state.pinsApproachImagesStateData = [
          ...state.pinsApproachImagesStateData,
          action.payload,
        ];
      }
    },
    pinsApproachImagesStateStatusAction: (state, action) => {
      state.pinsApproachImagesStateStatus = action.payload;
    },
    resetPinsApproachImagesStateDataAction: (state) => {
      state.pinsApproachImagesStateData = [];
    },
    getRotationStateDataActions: (state, action) => {
      state.getRotationStateData = action.payload;
    },
    getRotationDataStateStatusActions: (state, action) => {
      state.getRotationStateStatus = action.payload;
    },
    carPinPlacementStateDataAction: (state, action) => {
      state.carPinPlacementStateData = action.payload?.LatestEzLocatorPinHistory
        ? action.payload?.UpdatedPins
        : action.payload;
      state.carPinPlacementDataUpdated = action.payload
        ?.LatestEzLocatorPinHistory
        ? action.payload?.UpdatedPins?.CreationDateInUtc
        : action.payload?.CreationDateInUtc;
    },
    carPinPlacementStateStatusAction: (state, action) => {
      state.carPinPlacementStateStatus = action.payload;
    },
    greensWithPinPlacementStateDataAction: (state, action) => {
      state.greensWithPinPlacementStateData = action.payload;
      state.greensWithPinPlacementInfoStateData.specialRotationSets = [];
    },
    greensWithPinPlacementStateStatusAction: (state, action) => {
      state.greensWithPinPlacementStateStatus = action.payload;
    },
    setDailyRotationReduxStateAction: (state, action) => {
      state.dailyRotationReduxState = action.payload;
    },
    setSelectedInitialPinReduxStateAction: (state, action) => {
      state.selectedInitialPinsReduxData = action.payload;
    },
    greenWithPinPlacementDataInfoReduxStateAction: (state, action) => {
      const { rotationType, value } = action.payload;
      if (rotationType === "dailyrotation") {
        state.greensWithPinPlacementInfoStateData = {
          ...state.greensWithPinPlacementInfoStateData,
          dailyRotationSets: {
            ...state.greensWithPinPlacementInfoStateData.dailyRotationSets,
            value,
          },
        };
      } else if (rotationType === "specialrotation") {
        const specialrotationExists = value && value.length > 0 ?
          state.greensWithPinPlacementInfoStateData.specialRotationSets.find(
            (item) => item.Marker ===  value[0].Marker
          ): false;
        if (specialrotationExists) {
          state.greensWithPinPlacementInfoStateData.specialRotationSets.filter(
            (item) => item.Marker !== value[0].Marker
          );
        } else {
          state.greensWithPinPlacementInfoStateData = {
            ...state.greensWithPinPlacementInfoStateData,
            specialRotationSets: [
              ...state.greensWithPinPlacementInfoStateData.specialRotationSets,
              ...value,
            ],
          };
        }
      }
    },
    updatePinRotationStateDataAction: (state, action) => {
      state.updatePinRotationStateData = action.payload;
    },
    updatePinRotationStateDataStatusAction: (state, action) => {
      state.updatePinRotationStateDataStatus = action.payload;
    },
    saveCourseRotationDaysStatusAction: (state, action) => {
      state.saveCourseRotationDaysStatus = action.payload;
    },
    deleteMessagesSettingStatus: (state, action) => {
      state.deleteMessagesSettingStatus = action.payload;
    },
    deleteMessagesSettingData: (state, action) => {
      state.deleteMessagesSettingData = action.payload;
    },
    deleteCampaignStatus: (state, action) => {
      state.deleteCampaignStatus = action.payload;
    },
    deleteCampaignData: (state, action) => {
      state.deleteCampaignData = action.payload;
    },
    vduMessagesSettingData: (state, action) => {
      state.vduMessagesSettingData = action.payload;
    },
    vduMessagesSettingStatus: (state, action) => {
      state.vduMessagesSettingStatus = action.payload;
    },
    sendMessagesSettingData: (state, action) => {
      state.sendMessagesSettingData = action.payload;
    },
    sendMessagesSettingStatus: (state, action) => {
      state.sendMessagesSettingStatus = action.payload;
    },
    postHoleAreaData: (state, action) => {
      state.postHoleAreaData = action.payload;
    },
    postHoleAreaStatus: (state, action) => {
      state.postHoleAreaStatus = action.payload;
    },
    putMessagesSettingStatus: (state, action) => {
      state.putMessagesSettingStatus = action.payload;
    },
    putMessagesSettingStatus2: (state, action) => {
      state.putMessagesSettingStatus2 = action.payload;
    },
    saveCourseRotationDaysDataAction: (state, action) => {
      state.saveCourseRotationDaysData = action.payload;
    },

    getImageGalleryDataAction: (state, action) => {
      state.getImageGalleryData = action.payload;
    },
    rotationDataActions: (state, action) => {
      state.saveCourseRotationSetsData = action.payload;
    },
    rotationDataStatusActions: (state, action) => {
      state.saveCourseRotationSetsStatus = action.payload;
    },
    getExportUsageState: (state, action) => {
      state.getExportUsageState = action.payload;
    },
    getRoundsByCarStatus: (state, action) => {
      state.getRoundsByCarStatus = action.payload;
    },
    getRoundsByCarState: (state, action) => {
      state.getRoundsByCarState = action.payload;
    },
    getExportUsageStatus: (state, action) => {
      state.getExportUsageStatus = action.payload;
    },
    getImageGalleryStatusAction: (state, action) => {
      state.getImageGalleryStatus = action.payload;
    },
    getAdImageDataAction: (state, action) => {
      const { base64data, payload2 } = action.payload;
      const exists = state.getAdImageData.findIndex(
        (item) => item?.base64data === base64data
      );
      if (exists !== -1) {
        let data = JSON.parse(JSON.stringify(state.getAdImageData));
        data[exists] = { base64data, ...payload2 };
        state.getAdImageData = data;
      } else {
        state.getAdImageData = [
          ...state.getAdImageData,
          { base64data, ...payload2 },
        ];
      }
    },
    getAdImageStatusAction: (state, action) => {
      state.getAdImageStatus = action.payload;
    },
    getDashboardFullImagesDataStateAction: (state, action) => {
      const { base64data, payload2 } = action.payload;

      const exists = state.getDashboardFullImagesDataState.findIndex(
        (item) => item?.base64data === base64data
      );
      if (exists !== -1) {
        let data = JSON.parse(
          JSON.stringify(state.getDashboardFullImagesDataState)
        );
        data[exists] = { base64data, ...payload2 };
        state.getDashboardFullImagesDataState = data;
      } else {
        state.getDashboardFullImagesDataState = [
          ...state.getDashboardFullImagesDataState,
          { base64data, ...payload2 },
        ];
      }
    },
    getDashboardFullImagesDataStatusAction: (state, action) => {
      state.getDashboardFullImagesDataStatus = action.payload;
    },
    getDashboardInsertImagesDataStateAction: (state, action) => {
      const { base64data, payload2 } = action.payload;
      const exists = state.getDashboardInsertImagesDataState.findIndex(
        (item) => item?.base64data === base64data
      );
      if (exists !== -1) {
        let data = JSON.parse(
          JSON.stringify(state.getDashboardInsertImagesDataState)
        );
        data[exists] = { base64data, ...payload2 };
        state.getDashboardInsertImagesDataState = data;
      } else {
        state.getDashboardInsertImagesDataState = [
          ...state.getDashboardInsertImagesDataState,
          { base64data, ...payload2 },
        ];
      }
    },
    getDashboardInsertImagesDataStatusAction: (state, action) => {
      state.getDashboardInsertImagesDataStatus = action.payload;
    },
    getResetDashboardDataStateAction: (state) => {
      state.getDashboardFullImagesDataState = [];
    },
    getResetInsertDashboardDataStateAction: (state) => {
      state.getDashboardInsertImagesDataState = [];
    },

    resetGetAdImageDataAction: (state) => {
      state.getAdImageData = [];
    },

    getAdInsertImageDataAction: (state, action) => {
      const { base64data, payload2 } = action.payload;

      const exists = state.getAdInsertImageData.findIndex(
        (item) => item?.base64data === base64data
      );
      if (exists !== -1) {
        let data = JSON.parse(JSON.stringify(state.getAdInsertImageData));
        data[exists] = { base64data, ...payload2 };
        state.getAdInsertImageData = data;
      } else {
        state.getAdInsertImageData = [
          ...state.getAdInsertImageData,
          { base64data, ...payload2 },
        ];
      }
    },

    getAdInsertImageStatusAction: (state, action) => {
      state.getAdInsertImageStatus = action.payload;
    },
    putImageDescDataAction: (state, action) => {
      state.putImageDescData = action.payload;
    },
    putImageDescDataStatusAction: (state, action) => {
      state.putImageDescDataStatus = action.payload;
    },
    deleteImageDataAction: (state, action) => {
      state.deleteImageData = action.payload;
    },
    deleteImageDataStatusAction: (state, action) => {
      state.deleteImageDataStatus = action.payload;
    },
    addNewCampaignDataAction: (state, action) => {
      state.addNewCampaignDataAction = action.payload;
    },
    addNewCampaignStatusAction: (state, action) => {
      state.addNewCampaignStatusAction = action.payload;
    },
    saveWorksheetDataAction: (state, action) => {
      state.saveWorksheetDataAction = action.payload;
    },
    saveWorksheetStatusAction: (state, action) => {
      state.saveWorksheetStatusAction = action.payload;
    },
    getBaseCampaignDataAction: (state, action) => {
      state.getBaseCampaignData = action.payload;
    },
    getBaseCampaignStatusAction: (state, action) => {
      state.getBaseCampaignStatus = action.payload;
    },

    vduPutMessagesSettingStatus: (state, action) => {
      state.vduPutMessagesSettingStatus = action.payload;
    },

    getCampaignsStatus: (state, action) => {
      state.getCampaignsStatus = action.payload;
    },
    getCampaignsStateData: (state, action) => {
      state.getCampaignsStateData = action.payload;
    },
    copyCampaignsStatus: (state, action) => {
      state.copyCampaignsStatus = action.payload;
    },
    copyCampaignsData: (state, action) => {
      state.copyCampaignsData = action.payload;
    },

    deleteImagesStatus: (state, action) => {
      state.deleteImagesStatus = action.payload;
    },
    deleteImagesData: (state, action) => {
      state.deleteImagesData = action.payload;
    },

    deleteMultipleCampaignStatus: (state, action) => {
      state.deleteMultipleCampaignStatus = action.payload;
    },
    deleteMultipleCampaignData: (state, action) => {
      state.deleteMultipleCampaignData = action.payload;
    },

    getArchiveStatus: (state, action) => {
      state.getArchiveStatus = action.payload;
    },
    getArchiveData: (state, action) => {
      state.getArchiveData = action.payload;
    },

    addImageStatus: (state, action) => {
      state.addImageStatus = action.payload;
    },
    addImageData: (state, action) => {
      state.addImageData = action.payload;
    },

    putSiteAreaDataStatus: (state, action) => {
      state.putSiteAreaDataStatusAction = action.payload;
    },
    putSiteAreaData: (state, action) => {
      state.putSiteAreaDataAction = action.payload;
    },

    getWelcomeAdsDataStatus: (state, action) => {
      state.getWelcomeAdsDataStatus = action.payload;
    },
    getWelcomeAdsData: (state, action) => {
      state.getWelcomeAdsData = action.payload;
    },

    dashboardPaceStatus: (state, action) => {
      state.dashboardPaceStatus = action.payload;
    },
    dashboardPaceData: (state, action) => {
      state.dashboardPaceData = action.payload;
    },
    publishSetupData: (state, action) => {
      state.publishSetupData = action.payload;
    },
    postSiteAreaStatus: (state, action) => {
      state.postSiteAreaStatusAction = action.payload;
    },
    postSiteAreaDataState: (state, action) => {
      state.postSiteAreaDataStateAction = action.payload;
    },

    putHoleAreaDataStatus: (state, action) => {
      state.putHoleAreaDataStatusAction = action.payload;
    },
    putHoleAreaData: (state, action) => {
      state.putHoleAreaDataAction = action.payload;
    },

    deleteHoleAreaStatus: (state, action) => {
      state.deleteHoleAreaStatusAction = action.payload;
    },
    deleteHoleAreaData: (state, action) => {
      state.deleteHoleAreaDataAction = action.payload;
    },

    deleteSiteAreaStatus: (state, action) => {
      state.deleteSiteAreaStatusAction = action.payload;
    },
    deleteSiteAreaData: (state, action) => {
      state.deleteSiteAreaDataAction = action.payload;
    },

    putCOGDataStatusAction: (state, action) => {
      state.PutCOGDataStatus = action.payload;
    },
    putCOGDataAction: (state, action) => {
      state.PutCOGDataState = action.payload;
    },
    publishSiteDataAction: (state, action) => {
      state.publishSiteData = action.payload;
    },
    publishSiteStatusAction: (state, action) => {
      state.publishSiteStatus = action.payload;
    },
    addActionZoneStateAction: (state, action) => {
      state.addActionZoneState = action.payload;
    },
    addActionZoneStatusAction: (state, action) => {
      state.addActionZoneStatus = action.payload;
    },
    editActionZoneStateAction: (state, action) => {
      state.editActionZoneState = action.payload;
    },
    editActionZoneStatusAction: (state, action) => {
      state.editActionZoneStatus = action.payload;
    },
    deleteActionZoneStateAction: (state, action) => {
      state.deleteActionZoneState = action.payload;
    },
    deleteActionZoneStatusAction: (state, action) => {
      state.deleteActionZoneStatus = action.payload;
    },
    teeMarkerDataStateAction: (state, action) => {
      state.teeMarkerDataState = action.payload;
    },
    teeMarkerStatusAction: (state, action) => {
      state.teeMarkerStatus = action.payload;
    },
    deleteTeeMarkerDataStateAction: (state, action) => {
      state.deleteTeeMarkerDataState = action.payload;
    },
    deleteTeeMarkerStatusAction: (state, action) => {
      state.deleteTeeMarkerStatus = action.payload;
    },
    poiMarkerDataStateAction: (state, action) => {
      state.poiMarkerDataState = action.payload;
    },
    poiMarkerStatusAction: (state, action) => {
      state.poiMarkerStatus = action.payload;
    },
    deletePoiMarkerDataStateAction: (state, action) => {
      state.deletePoiMarkerDataState = action.payload;
    },
    deletePoiMarkerStatusAction: (state, action) => {
      state.deletePoiMarkerStatus = action.payload;
    },
    putPoiMarkerDataStateAction: (state, action) => {
      state.putPoiMarkerDataState = action.payload;
    },
    putPoiMarkerStatusAction: (state, action) => {
      state.putPoiMarkerStatus = action.payload;
    },
    putTeeMarkerDataStateAction: (state, action) => {
      state.putTeeMarkerDataState = action.payload;
    },
    putTeeMarkerStatusAction: (state, action) => {
      state.putTeeMarkerStatus = action.payload;
    },
    carBehindPaceDataStateAction: (state, action) => {
      state.carBehindPaceData = action.payload;
    },
    carBehindPaceDataStatusAction: (state, action) => {
      state.carBehindPaceDataStatus = action.payload;
    },
    getDashboardState: (state, action) => {
      state.getDashboardState = action.payload;
    },
    getDashboardRidingCarState: (state, action) => {
      state.getDashboardRidingCarState = action.payload;
    },
    getDashboardStatus: (state, action) => {
      state.getDashboardStatus = action.payload;
    },
    getDispatchCarRidingStatus: (state, action) => {
      state.getDispatchCarRidingStatus = action.payload;
    },
    getWeatherInfoDataStateAction: (state, action) => {
      state.getWeatherInfoDataState = action.payload;
    },
    getWeatherInfoDataStatusAction: (state, action) => {
      state.getWeatherInfoDataStatus = action.payload;
    },
    getActionZoneInfractionDataStateActon: (state, action) => {
      state.getActionZoneInfractionDataState = action.payload;
    },
    getActionZoneInfractionDataStatusAction: (state, action) => {
      state.getActionZoneInfractionDataStatus = action.payload;
    },
    getActionZoneInfractionChildDataStateAction: (state, action) => {
      state.getActionZoneInfractionChildDataState = action.payload;
    },
    getActionZoneInfractionChildDataStatusAction: (state, action) => {
      state.getActionZoneInfractionChildDataStatus = action.payload;
    },
    getDashboardCampaignAdsStateAction: (state, action) => {
      state.getDashboardCampaignAdsState = action.payload;
    },
    getDashboardCampaignAdsStatusAction: (state, action) => {
      state.getDashboardCampaignAdsStatus = action.payload;
    },
    getCarSelectionStateAction: (state, action) => {
      state.getCarSelectionState = action.payload;
    },
    getCarSelectionStatusAction: (state, action) => {
      state.getCarSelectionStatus = action.payload;
    },
    getCountCarBehindPaceStateAction: (state, action) => {
      state.getCountCarBehindPaceState = action.payload;
    },
    getCountCarBehindPaceStatusAction: (state, action) => {
      state.getCountCarBehindPaceStatus = action.payload;
    },
    getPaceByHoleState: (state, action) => {
      state.getPaceByHoleState = action.payload;
    },
    getPaceByHoleStatus: (state, action) => {
      state.getPaceByHoleStatus = action.payload;
    },

    getPrivilegesListAction: (state, action) => {
      state.getPrivilegesListAction = action.payload;
    },
    getPrivilegesListStatusAction: (state, action) => {
      state.getPrivilegesListStatusAction = action.payload;
    },
    getPrivilegeAction: (state, action) => {
      state.getPrivilegeAction = action.payload;
    },
    getPrivilegeStatusAction: (state, action) => {
      state.getPrivilegeStatusAction = action.payload;
    },
    getRolesListAction: (state, action) => {
      state.getRolesListAction = action.payload;
    },
    getRolesListStatusAction: (state, action) => {
      state.getRolesListStatusAction = action.payload;
    },

    getCarMovementState: (state, action) => {
      state.getCarMovementState = action.payload;
    },
    getCarMovementStatus: (state, action) => {
      state.getCarMovementStatus = action.payload;
    },

    getFleetReadinessState: (state, action) => {
      state.getFleetReadinessState = action.payload;
    },
    getFleetReadinessStatus: (state, action) => {
      state.getFleetReadinessStatus = action.payload;
    },
    getRoundsCompletedState: (state, action) => {
      state.getRoundsCompletedState = action.payload;
    },
    getRoundsCompletedStatus: (state, action) => {
      state.getRoundsCompletedStatus = action.payload;
    },
    getCarUsageState: (state, action) => {
      state.getCarUsageState = action.payload;
    },
    getCarUsageStatus: (state, action) => {
      state.getCarUsageStatus = action.payload;
    },

    getCarUsageDetailState: (state, action) => {
      state.getCarUsageDetailState = action.payload;
    },
    getCarUsageDetailStatus: (state, action) => {
      state.getCarUsageDetailStatus = action.payload;
    },

    getRoundsByCarDetailState: (state, action) => {
      state.getRoundsByCarDetailState = action.payload;
    },
    getRoundsByCarDetailStatus: (state, action) => {
      state.getRoundsByCarDetailStatus = action.payload;
    },

    getScoreCardState: (state, action) => {
      state.getScoreCardState = action.payload;
    },
    getScoreCardStatus: (state, action) => {
      state.getScoreCardStatus = action.payload;
    },
    getEmailAddressesState: (state, action) => {
      state.getEmailAddressesState = action.payload;
    },
    getEmailAddressesStatus: (state, action) => {
      state.getEmailAddressesStatus = action.payload;
    },
    putResendEmailState: (state, action) => {
      state.putResendEmailState = action.payload;
    },
    putResendEmailStatus: (state, action) => {
      state.putResendEmailStatus = action.payload;
    },
    getPreRoundCarsStateAction: (state, action) => {
      state.getPreRoundCarsState = action.payload;
    },
    getPreRoundCarsStatusAction: (state, action) => {
      state.getPreRoundCarsStatus = action.payload;
    },
    getDashboardBatteryNotificationStateAction: (state, action) => {
      state.getDashboardBatteryNotificationState = action.payload;
    },
    getDashboardBatteryNotificationStatusAction: (state, action) => {
      state.getDashboardBatteryNotificationStatus = action.payload;
    },
    getSiteAreasStateAction: (state, action) => {
      state.getSiteAreasState = action.payload;
    },
    getSiteAreasStatusAction: (state, action) => {
      state.getSiteAreasStatus = action.payload;
    },
    getHoleAreasStateAction: (state, action) => {
      state.getHoleAreasState = action.payload;
    },
    getHoleAreasStatusAction: (state, action) => {
      state.getHoleAreasStatus = action.payload;
    },
    getSingleCarTrackStateAction: (state, action) => {
      state.getSingleCarTrackState = action.payload;
    },
    getSingleCarTrackStatusAction: (state, action) => {
      state.getSingleCarTrackStatus = action.payload;
    },
    setSiteSettingDataReduxStateAction: (state, action) => {
      state.siteSettingDataReduxState = action.payload;
    },
    setSiteSettingDataReduxStateStatusAction: (state, action) => {
      state.siteSettingDataReduxStateStatus = action.payload;
    },
    getDashboardFeatureSetStateAction: (state, action) => {
      state.getDashboardFeatureSetState = action.payload;
    },
    getDashboardFeatureSetStatusAction: (state, action) => {
      state.getDashboardFeatureSetStatus = action.payload;
    },
    putDashboardFeatureSetStateAction: (state, action) => {
      state.putDashboardFeatureSetState = action.payload;
    },
    putDashboardFeatureSetStatusAction: (state, action) => {
      state.putDashboardFeatureSetStatus = action.payload;
    },
    getFeatureSetState: (state, action) => {
      state.getFeatureSetState = action.payload;
    },
    getFeatureSetStateStatus: (state, action) => {
      state.getFeatureSetStateStatus = action.payload;
    },
    setNewFeaturesStateAction: (state, action) => {
      state.setNewFeatureStateData = action.payload;
    },
    setNewFeaturesStatusAction: (state, action) => {
      state.setNewFeatureStateStatus = action.payload;
    },
    setCourseChangesResponseAction: (state, action) => {
      state.setCourseChangesResponseState = action.payload;
    },
    setCourseChangesStatusAction: (state, action) => {
      state.setCourseChangesStatusState = action.payload;
    },
    setTeeMarkerSettingsDataAction: (state, action) => {
      state.setUpdatedTeeMarkerSettingsData = action.payload;
    },
    setTeeMarkerSettingsStatusAction: (state, action) => {
      state.setUpdatedTeeMarkerSettingsStatus = action.payload;
    },
    addNewTeeMarkerSettingsDataAction: (state, action) => {
      state.addNewTeeMarkerSettingsData = action.payload;
    },
    addNewTeeMarkerSettingsStatusAction: (state, action) => {
      state.addNewTeeMarkerSettingsStatus = action.payload;
    },
    saveSharedTeeMarkerSettingsStatusAction: (state, action) => {
      state.sharedTeeMarkerSettingsStatus = action.payload;
    },
    deleteTeeSettingsStatusAction: (state, action) => {
      state.deleteTeeSettingsStatus = action.payload;
    },
    teeMarkerLoaderStatusHandler: (state, action) => {
      state.teeMarkerLoaderStatus = action.payload;
    },
    getPackageManifestsData: (state, action) => {
      state.getPackageManifestsData = action.payload;
    },
    getPackageManifestsStatus: (state, action) => {
      state.getPackageManifestsStatus = action.payload;
    },

    putCpoSettingsStateDataAction: (state, action) => {
      state.putCpoSettingsStateData = action.payload;
    },
    putCpoSettingsStatusAction: (state, action) => {
      state.putCpoSettingsStatus = action.payload;
    },
    getFaultsData: (state, action) => {
      state.getFaultsData = action.payload;
    },
    getFaultsStatus: (state, action) => {
      state.getFaultsStatus = action.payload;
    },
    getFoodOrdersDataStateAction: (state, action) => {
      state.getFoodOrdersDataState = action.payload;
    },
    getFoodOrdersDataStatusAction: (state, action) => {
      state.getFoodOrdersDataStatus = action.payload;
    },

    getFoodImageDataStateAction: (state, action) => {
      state.getFoodImageDataState = action.payload;
    },
    getFoodImageDataStatusAction: (state, action) => {
      state.getFoodImageDataStatus = action.payload;
    },
    getFoodImageNamesDataStateAction: (state, action) => {
      state.getFoodImageNameDataState = action.payload;
    },
    getFoodImageNamesDataStatusAction: (state, action) => {
      state.getFoodImageDataStatus = action.payload;
    },
    getFoodOrdersTabDataStateAction: (state, action) => {
      state.getFoodOrdersTabDataState = action.payload;
    },
    getFoodOrdersTabDataStatusAction: (state, action) => {
      state.getFoodOrdersTabDataStatus = action.payload;
    },
    getFoodMenuTabDataStateAction: (state, action) => {
      state.getFoodMenuTabDataState = action.payload;
    },
    getFoodMenuTabDataStatusAction: (state, action) => {
      state.getFoodMenuTabDataStatus = action.payload;
    },
    putFoodMenuTabDataStateAction: (state, action) => {
      state.putFoodMenuTabDataState = action.payload;
    },
    putFoodMenuTabDataStatusAction: (state, action) => {
      state.putFoodMenuTabDataStatus = action.payload;
    },
    putFoodOrdersTabDataStateAction: (state, action) => {
      state.putFoodOrdersTabDataState = action.payload;
    },
    putFoodOrdersTabDataStatusAction: (state, action) => {
      state.putFoodOrdersTabDataStatus = action.payload;
    },
    putLocalisationState: (state, action) => {
      state.putLocalisationState = action.payload;
    },
    putLocalisationStatus: (state, action) => {
      state.putLocalisationStatus = action.payload;
    },
    getValidateZoneDataStatusAction: (state, action) => {
      state.getValidateZoneDataStatusAction = action.payload;
    },
    getValidateZoneDataStateAction: (state, action) => {
      state.getValidateZoneDataStateAction = action.payload;
    },

    getValidatePinDataStatusAction: (state, action) => {
      state.getValidatePinDataStatusAction = action.payload;
    },
    getValidatePinDataStateAction: (state, action) => {
      state.getValidatePinDataStateAction = action.payload;
    },
    getSiteSettingStatusAction: (state, action) => {
      state.getSiteSettingStatusAction = action.payload;
    },
    getSiteSettingStateAction: (state, action) => {
      state.getSiteSettingStateAction = action.payload;
    },
    getPaceManifestStatusAction: (state, action) => {
      state.getPaceManifestStatusAction = action.payload;
    },
    getPaceManifestStateAction: (state, action) => {
      state.getPaceManifestStateAction = action.payload;
    },
    getMessageManifestStatusAction: (state, action) => {
      state.getMessageManifestStatusAction = action.payload;
    },
    getMessageManifestStateAction: (state, action) => {
      state.getMessageManifestStateAction = action.payload;
    },
    getLanguageManifestStatusAction: (state, action) => {
      state.getLanguageManifestStatusAction = action.payload;
    },
    getLanguageManifestStateAction: (state, action) => {
      state.getLanguageManifestStateAction = action.payload;
    },
    getSimpleCarManifestStatusAction: (state, action) => {
      state.getSimpleCarManifestStatusAction = action.payload;
    },
    getSimpleCarManifestStateAction: (state, action) => {
      state.getSimpleCarManifestStateAction = action.payload;
    },
    getManifestListStatusAction: (state, action) => {
      state.getManifestListStatusAction = action.payload;
    },
    getManifestListStateAction: (state, action) => {
      state.getManifestListStateAction = action.payload;
    },
    getChangePasswordStatusAction: (state, action) => {
      state.getChangePasswordStatus = action.payload;
    },
    getChangePasswordStateAction: (state, action) => {
      state.getChangePasswordState = action.payload;
    },
    resetChangePasswordStateAction: (state) => {
      state.getChangePasswordState = {};
    },
    getSeveralListStatus: (state, action) => {
      state.getSeveralListStatus = action.payload;
    },
    getSeveralListState: (state, action) => {
      state.getSeveralListState = action.payload;
    },
    getSettingListState: (state, action) => {
      state.getSettingListState = action.payload;
    },
    getSettingListStatus: (state, action) => {
      state.getSettingListStatus = action.payload;
    },
    getMessageListState: (state, action) => {
      state.getMessageListState = action.payload;
    },
    getMessageListStatus: (state, action) => {
      state.getMessageListStatus = action.payload;
    },
    getPaceListState: (state, action) => {
      state.getPaceListState = action.payload;
    },
    getPaceListStatus: (state, action) => {
      state.getPaceListStatus = action.payload;
    },
    getLanguageListState: (state, action) => {
      state.getLanguageListState = action.payload;
    },
    getLanguageListStatus: (state, action) => {
      state.getLanguageListStatus = action.payload;
    },
    getSimpleCarListState: (state, action) => {
      state.getSimpleCarListState = action.payload;
    },
    getSimpleCarListStatus: (state, action) => {
      state.getSimpleCarListStatus = action.payload;
    },
    putHoleDataStateAction: (state, action) => {
      state.putHoleDataState = action.payload;
    },
    putHoleDataStatusAction: (state, action) => {
      state.putHoleDataStatus = action.payload;
    },
    setAdminCodeStateAction: (state, action) => {
      state.setAdminCodeState = action.payload;
    },
    setAdminCodeStatusAction: (state, action) => {
      state.setAdminCodeStatus = action.payload;
    },
    setMessageStateAction: (state, action) => {
      state.setMessageStateAction = action.payload;
    },
    setMessageStatusAction: (state, action) => {
      state.setMessageStatusAction = action.payload;
    },
    uploadKmlDataStateAction: (state, action) => {
      state.uploadKmlDataState = action.payload;
    },
    uploadKmlDataStatusAction: (state, action) => {
      state.uploadKmlDataStatus = action.payload;
    },
    createHoleMapImageDataStatusAction: (state, action) => {
      state.createHoleMapImageDataStatus = action.payload;
    },
    createHoleMapImageDataStateAction: (state, action) => {
      state.createHoleMapImageDataState = action.payload;
    },
    processGreenViewDataStatusAction: (state, action) => {
      state.processGreenViewDataStatus = action.payload;
    },
    processGreenViewDataStateAction: (state, action) => {
      state.processGreenViewDataState = action.payload;
    },
    putMaxVolumeSettingStatusAction: (state, action) => {
      state.putMaxVolumeSettingStatus = action.payload;
    },
    sendMessageToMarshalsStatus: (state, action) => {
      state.sendMessageToMarshalsStatus = action.payload;
    },
    sendMessageToMarshalsData: (state, action) => {
      state.sendMessageToMarshalsData = action.payload;
    },
    getMinVersForNewAZsStatus: (state, action) => {
      state.getMinVersForNewAZsStatus = action.payload;
    },
    getMinVersForNewAZsData: (state, action) => {
      state.getMinVersForNewAZsData = action.payload;
    },
    publishWaiverTemplatesStatus: (state, action) => {
      state.publishWaiverTemplatesStatus = action.payload;
    },
    unpublishWaiverTemplatesStatus: (state, action) => {
      state.unpublishWaiverTemplatesStatus = action.payload;
    },
    saveWaiverTemplatesStatus: (state, action) => {
      state.saveWaiverTemplatesStatus = action.payload;
    },
    saveWaiverTemplatesData: (state, action) => {
      state.saveWaiverTemplatesData = action.payload;
    },    
    getWaiverTemplatesStatus: (state, action) => {
      state.getWaiverTemplatesStatus = action.payload;
    },
    getWaiverTemplatesData: (state, action) => {
      state.getWaiverTemplatesData = action.payload;
    },
    getTournSettingsStatus: (state, action) => {
      state.getTournSettingsStatus = action.payload;
    },
    getTournSettingsState: (state, action) => {
      state.getTournSettingsState = action.payload;
    }
  },
});

export const {
  setMessageStateAction,
  setMessageStatusAction,
  teeMarkerLoaderStatusHandler,
  getSimpleCarListStatus,
  getSimpleCarListState,
  getLanguageListStatus,
  getLanguageListState,
  getPaceListStatus,
  getPaceListState,
  getMessageListStatus,
  getMessageListState,
  getSettingListStatus,
  getSettingListState,
  saveSharedTeeMarkerSettingsStatusAction,
  setHoleDataPinsState,
  deleteTeeSettingsStatusAction,
  setSharedCheckboxSTatusReduxStateAction,
  setSharedCheckboxDataReduxStateAction,
  setCourseChangesResponseAction,
  setCourseChangesStatusAction,
  setTeeMarkerSettingsDataAction,
  setTeeMarkerSettingsStatusAction,
  addNewTeeMarkerSettingsDataAction,
  addNewTeeMarkerSettingsStatusAction,
  siteSettingsDataReduxStateAction,
  siteSettingsDataReduxStateStatusAction,
  getFeatureSetState,
  getFeatureSetStateStatus,
  setNewFeaturesStateAction,
  setNewFeaturesStatusAction,
  setPinsEditModeReduxStateAction,
  setPinsAdminModeReduxStateAction,
  resetHoleDataPinState,
  getWeatherInfoDataStateAction,
  greenWithPinPlacementDataInfoReduxStateAction,
  setSelectedInitialPinReduxStateAction,
  getCarUsageDetailState,
  setClickToDriveApiDataAction,
  setClickToDriveApiStatusAction,
  getCarUsageDetailStatus,
  getRoundsByCarDetailState,
  getRoundsByCarDetailStatus,
  getWeatherInfoDataStatusAction,
  setHoleDataReduxState,
  getActionZoneInfractionChildDataStateAction,
  getActionZoneInfractionChildDataStatusAction,
  setUpdatedPinLocationReduxState,
  getActionZoneInfractionDataStateActon,
  getActionZoneInfractionDataStatusAction,
  mapInformationData,
  getExportUsageState,
  getExportUsageStatus,
  mapInformationStatus,
  updateCarTypeData,
  updateCarStatus,
  loginUserData,
  setLoginUserStatus,
  getVerificationLinkData,
  getVerificationLinkStatus,
  resetUsernameData,
  resetUsernameStatus,
  changePasswordData,
  changePasswordStatus,
  resetPasswordData,
  resetPasswordStatus,
  getCarsDataAction,
  getCurrentCarsDataAction,
  getCarsStatusAction,
  getCarPathActionZoneAction,
  getCarPathActionZoneStatusAction,
  holeMarkerDataAction,
  holeMarkerStatusAction,
  sendMessagesData,
  sendMessagesStatus,
  getDashboardCartPathDetailData,
  getDashboardCartPathDetailStatus,
  cannedMessagesData,
  cannedMessagesStatus,
  getAnnouncementsData,
  getAnnouncementsStatus,
  acknowledgeAnnouncementsData,
  acknowledgeAnnouncementsStatus,
  mapImageData,
  mapImageStatus,
  mapXYPointsData,
  mapXYPointsStatus,
  siteSetupData,
  siteSetupStatus,
  getCarHistoryData,
  getCarHistoryStatus,
  specificCarHistoryDataAction,
  specificCarHistoryStatusAction,
  allCarsHistoryDataAction,
  allCarsHistoryStatusAction,
  siteSettingsData,
  getRoundsByDayStatus,
  getRoundsByDayState,
  deleteHoleAreaStatus,
  deleteHoleAreaData,
  deleteSiteAreaStatus,
  deleteSiteAreaData,
  siteSettingsStatus,
  getWelcomeAdsDataStatus,
  getWelcomeAdsData,
  saveEmailData,
  getRoundsByCarStatus,
  getRoundsByCarState,
  saveEmailStatus,
  deleteEmailData,
  deleteEmailStatus,
  alertMessageData,
  alertMessageStatus,
  sendTestEmailData,
  sendTestEmailStatus,
  updateEmailData,
  updateEmailStatus,
  stagingModeDataAction,
  stagingModeStatusAction,
  kmlLayerData,
  kmlLayerDataStatus,
  messagesHistoryData,
  messagesHistoryStatus,
  fleetSettingslData,
  fleetSettingslData2,
  fleetSettingsStatus,
  antiTamperSelectionData,
  antiTamperSelectionStatus,
  fleetSettingsStatus2,
  getCarTrackData,
  getCarTrackStatus,
  getCarTracksData,
  getCarTracksStatus,
  getUserRole,
  getUserRoleStatus,
  putWelcomeScreenTextMessageAction,
  putWelcomeScreenTextMessageStatusAction,
  carPropertiesData,
  carPropertiesStatus,
  getSiteOffPeakCharginData,
  getSiteOffPeakCharginStatus,
  getScheduledFleetLockdownData,
  getScheduledFleetLockdownStatus,
  carLocationData,
  carLocationStatus,
  carProductData,
  carProductStatus,
  carProductLoader,
  siteLocationsStatus,
  siteLocationsData,
  pinsApproachImagesStateDataAction,
  pinsApproachImagesStateStatusAction,
  carPinPlacementStateDataAction,
  carPinPlacementStateStatusAction,
  greensWithPinPlacementStateDataAction,
  greensWithPinPlacementStateStatusAction,
  setDailyRotationReduxStateAction,
  rotationDataActions,
  rotationDataStatusActions,
  getRotationStateDataActions,
  getRotationDataStateStatusActions,
  saveCourseRotationDaysDataAction,
  saveCourseRotationDaysStatusAction,
  deleteMessagesSettingStatus,
  deleteMessagesSettingData,
  vduMessagesSettingStatus,
  setOldMessagesBackUpReduxState,
  setNewMessagesBackUpReduxState,
  setNewFoodOrderReduxState,
  setOldFoodOrderReduxState,
  vduMessagesSettingData,
  sendMessagesSettingStatus,
  sendMessagesSettingData,
  postHoleAreaData,
  postHoleAreaStatus,
  putMessagesSettingData,
  putMessagesSettingStatus,
  vduPutMessagesSettingStatus,
  putMessagesSettingData2,
  putMessagesSettingStatus2,
  vduPutMessagesSettingData,
  getImageGalleryDataAction,
  getImageGalleryStatusAction,
  getAdImageDataAction,
  getAdImageStatusAction,
  getAdInsertImageDataAction,
  getAdInsertImageStatusAction,
  putImageDescDataAction,
  putImageDescDataStatusAction,
  deleteImageDataAction,
  deleteImageDataStatusAction,
  resetPinsApproachImagesStateDataAction,
  putScoreCardEmailAction,
  putScoreCardEmailStatusAction,
  putMaxHoleServicesAction,
  putMaxHoleServicesStatus,
  postSavePersistentCarTypeSettingStatus,
  postSavePersistentCarTypeSettingAction,
  putRemovePersistentCarTypeSettingStatus,
  putRemovePersistentCarTypeSettingAction,
  putDisableDistanceAction,
  putDisableDistanceStatus,
  putBehindPaceWarningAction,
  putBehindPaceWarningStatus,
  putPaceStatusTimeAction,
  putPaceStatusTimeStatus,
  putUpdatedLockAction,
  putUpdatedLockStatus,
  putUpdateMemberCarTrackingAction,
  putUpdateMemberCarTrackingStatus,
  putSiteOffAction,
  putSiteOffStatus,
  dashboardPaceStatus,
  dashboardPaceData,
  publishSetupData,
  getRoundTimeOutAction,
  getRoundTimeOutState,
  putRoundTimeOutData,
  putRoundTimeOutStatusAction,
  getMessagesFromCarsData,
  setOnlyMessagesReduxState,
  getMessagesFromCarsStatus,
  getPartialSiteSettingsData,
  getPartialSiteSettingsStatus,
  getProgressPendingForSiteData,
  getProgressPendingForSiteStatus,
  getVersionStringData,
  getVersionStringStatus,
  deleteCampaignData,
  deleteCampaignStatus,
  getCampaignsStatus,
  getCampaignsStateData,
  addNewCampaignDataAction,
  addNewCampaignStatusAction,
  saveWorksheetDataAction,
  saveWorksheetStatusAction,
  updatePinRotationStateDataAction,
  updatePinRotationStateDataStatusAction,
  copyCampaignsStatus,
  copyCampaignsData,
  deleteImagesStatus,
  deleteImagesData,
  deleteMultipleCampaignData,
  deleteMultipleCampaignStatus,
  getBaseCampaignDataAction,
  getBaseCampaignStatusAction,
  getArchiveData,
  getArchiveStatus,
  addImageData,
  addImageStatus,
  putCOGDataAction,
  putCOGDataStatusAction,
  putHoleAreaData,
  getExportRoundByCarState,
  getExportRoundByCarStatus,
  putHoleAreaDataStatus,
  putSiteAreaData,
  putSiteAreaDataStatus,
  postSiteAreaStatus,
  postSiteAreaDataState,
  publishSiteDataAction,
  publishSiteStatusAction,
  addActionZoneStateAction,
  addActionZoneStatusAction,
  teeMarkerDataStateAction,
  teeMarkerStatusAction,
  poiMarkerDataStateAction,
  poiMarkerStatusAction,
  resetSiteDataVersionAction,
  resetSiteDataVersionStatusAction,
  sendMapDataAction,
  sendMapDataStatusAction,
  sendGreenViewDataAction,
  sendGreenViewDataStatusAction,
  sendSiteDataAction,
  sendSiteDataStatusAction,
  sendPOIDataAction,
  sendPOIDataStatusAction,
  scheduleSiteDataPublishAction,
  scheduleSiteDataPublishStatusAction,
  sendTeeMarkerDataAction,
  sendTeeMarkerDataStatusAction,
  clearSiteDataAction,
  clearSiteDataStatusAction,
  resetPOIsVersionAction,
  resetPOIsVersionStatusAction,
  getPackageManifestsData,
  getPackageManifestsStatus,
  assignManifestToCarsData,
  assignManifestToCarsStatus,
  resetMapsVersionAction,
  resetMapsVersionStatusAction,
  resetGreenViewVersionAction,
  resetGreenViewVersionStatusAction,
  resetTeeMarkersVersionAction,
  resetTeeMarkersVersionStatusAction,
  createSiteDataAction,
  createSiteDataStatusAction,
  resetSiteExtentsAndCtrPtToZeroAction,
  resetSiteExtentsAndCtrPtToZeroStatusAction,
  setSiteExtentsAction,
  setSiteExtentsStatusAction,
  disableAllAZsForMemberCarsAction,
  disableAllAZsForMemberCarsStatusAction,
  enableAllAZsForMemberCarsAction,
  enableAllAZsForMemberCarsStatusAction,
  deleteTeeMarkerDataStateAction,
  deleteTeeMarkerStatusAction,
  deletePoiMarkerDataStateAction,
  deletePoiMarkerStatusAction,
  putPoiMarkerDataStateAction,
  putPoiMarkerStatusAction,
  putTeeMarkerDataStateAction,
  putTeeMarkerStatusAction,
  editActionZoneStateAction,
  editActionZoneStatusAction,
  deleteActionZoneStatusAction,
  deleteActionZoneStateAction,
  resetGetAdImageDataAction,
  carBehindPaceDataStateAction,
  carBehindPaceDataStatusAction,
  getPrivilegesListAction,
  getPrivilegesListStatusAction,
  getPrivilegeAction,
  getPrivilegeStatusAction,
  getRolesListAction,
  getRolesListStatusAction,
  getDashboardState,
  getDashboardRidingCarState,
  getDashboardStatus,
  getDispatchCarRidingStatus,
  getCarSelectionStateAction,
  getCarSelectionStatusAction,
  getCountCarBehindPaceStateAction,
  getCountCarBehindPaceStatusAction,
  getPaceByHoleState,
  getPaceByHoleStatus,
  getCarMovementStatus,
  getCarMovementState,
  getFleetReadinessState,
  getFleetReadinessStatus,
  getRoundsCompletedState,
  getRoundsCompletedStatus,
  getCarUsageStatus,
  getCarUsageState,
  getDashboardCampaignAdsStateAction,
  getDashboardCampaignAdsStatusAction,
  getDashboardFullImagesDataStateAction,
  getDashboardFullImagesDataStatusAction,
  getDashboardInsertImagesDataStateAction,
  getDashboardInsertImagesDataStatusAction,
  getResetDashboardDataStateAction,
  getResetInsertDashboardDataStateAction,
  getScoreCardState,
  getEmailAddressesState,
  getScoreCardStatus,
  getEmailAddressesStatus,
  putResendEmailState,
  putResendEmailStatus,
  getPreRoundCarsStateAction,
  getPreRoundCarsStatusAction,
  getDashboardBatteryNotificationStateAction,
  getDashboardBatteryNotificationStatusAction,
  getSiteAreasStateAction,
  getSiteAreasStatusAction,
  getHoleAreasStateAction,
  getHoleAreasStatusAction,
  setSiteSettingDataReduxStateAction,
  setSiteSettingDataReduxStateStatusAction,
  getTodayPinPositionDataReduxStateAction,
  getTodayPinPositionDataReduxStatusAction,
  getSingleCarTrackStateAction,
  getSingleCarTrackStatusAction,
  getDashboardFeatureSetStateAction,
  getDashboardFeatureSetStatusAction,
  putDashboardFeatureSetStateAction,
  putDashboardFeatureSetStatusAction,
  putCpoSettingsStateDataAction,
  putCpoSettingsStatusAction,
  setCustomerServiceProfileStatus,
  setCustomerServiceProfileData,
  saveCustomerServiceProfileSettingStatus,
  deleteMessagesReduxState,
  getFaultsData,
  getFaultsStatus,
  setPinMovementDetectorAction,
  getFoodOrdersDataStateAction,
  getFoodOrdersDataStatusAction,
  getFoodImageDataStatusAction,
  getFoodImageDataStateAction,
  getFoodImageNamesDataStateAction,
  getFoodImageNamesDataStatusAction,
  getFoodOrdersTabDataStateAction,
  getFoodOrdersTabDataStatusAction,
  getFoodMenuTabDataStateAction,
  getFoodMenuTabDataStatusAction,
  putFoodOrdersTabDataStateAction,
  putFoodMenuTabDataStatusAction,
  putFoodMenuTabDataStateAction,
  putFoodOrdersTabDataStatusAction,
  setUpdatedCarsDataState,
  putLocalisationState,
  putLocalisationStatus,
  getVisageUsersStatusAction,
  getVisageUsersAction,
  getVisagaUsersListAction,
  getVisagaUsersListStatusAction,
  getValidateZoneDataStateAction,
  getValidateZoneDataStatusAction,
  getValidatePinDataStateAction,
  getValidatePinDataStatusAction,
  getSiteSettingStatusAction,
  getSiteSettingStateAction,
  getPaceManifestStatusAction,
  getPaceManifestStateAction,
  getMessageManifestStatusAction,
  getMessageManifestStateAction,
  getLanguageManifestStatusAction,
  getLanguageManifestStateAction,
  getSimpleCarManifestStatusAction,
  getSimpleCarManifestStateAction,
  getManifestListStatusAction,
  getManifestListStateAction,
  getChangePasswordStatusAction,
  getChangePasswordStateAction,
  resetChangePasswordStateAction,
  putHoleDataStateAction,
  putHoleDataStatusAction,
  setAdminCodeStateAction,
  setAdminCodeStatusAction,
  uploadKmlDataStateAction,
  uploadKmlDataStatusAction,
  createHoleMapImageDataStatusAction,
  createHoleMapImageDataStateAction,
  processGreenViewDataStatusAction,
  processGreenViewDataStateAction,
  putMaxVolumeSettingStatusAction,
  sendMessageToMarshalsStatus,
  sendMessageToMarshalsData,
  getMinVersForNewAZsStatus,
  getMinVersForNewAZsData,
  publishWaiverTemplatesStatus,
  unpublishWaiverTemplatesStatus,
  saveWaiverTemplatesStatus,
  saveWaiverTemplatesData,
  getWaiverTemplatesStatus,
  getWaiverTemplatesData,
  getTournSettingsState,
  getTournSettingsStatus
} = commonReducers.actions;

export default commonReducers.reducer;
